export default __webpack_public_path__ + "23628387cdff0b1809da1af5523d05f2.jpg";